import { REMARK_CHANGE, REMARK_INIT } from '../../constants/ActionTypes';

function RemarkReducer(state = { flowId: '', status: '' }, { type: actionType, payload }) {
  if (actionType === REMARK_INIT) {
    // 预留不改变remark状态
    return {
      ...state,
      flowId: payload.flowId
    }
  }
  // 修改备注值/状态
  if (actionType === REMARK_CHANGE) {
    return {
      ...state,
      ...payload
    }
  }
  return state;
}

export default RemarkReducer;